/**
 * Shared Supabase client singleton.
 * Import from here instead of calling createClient() directly in components.
 * This prevents "Multiple GoTrueClient instances" warnings.
 */
import {createClient} from '@supabase/supabase-js';

const supabase =
    process.env.SUPABASE_URL && process.env.SUPABASE_ANON_KEY
        ? createClient(process.env.SUPABASE_URL, process.env.SUPABASE_ANON_KEY)
        : null;

export default supabase;
